/* Accessibility Batch 4a-1 (_ao) - move focus into the cart drawer on open (ATC success OR
 * manual cart-icon open). The drawer's localized accessible name + tabindex=-1 are set in
 * sections/cart-drawer.liquid. Additive: does NOT alter the drawer markup, the theme focus-trap
 * (already active on open), or return-focus on close (focus-trap stores the opener at activate()
 * time, so close returns to the ATC button or cart icon). No inert / background blocking; the 3B
 * live region is untouched.
 */
(function () {
  if (window.__aoCartDrawerFocusInit) return;
  window.__aoCartDrawerFocusInit = true;

  function init() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    // Move focus into the named drawer whenever it opens (APG dialog pattern). Guard: if focus
    // is already inside the drawer (e.g. the theme/focus-trap placed it), don't override it.
    drawer.addEventListener('dialog:after-show', function () {
      if (!drawer.hasAttribute('open')) return;
      var active = document.activeElement;
      if (active === drawer || drawer.contains(active)) return;
      try { drawer.focus({ preventScroll: true }); } catch (e) { drawer.focus(); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
